import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../utill/validation";
import { Collapse, Row, Space } from "antd";
import axios from "axios";
import api from "../config.json";
import Table from "../Common/table";
import dateTime from "../utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../utill/Excelimport";
import Loading from "../utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import _ from "lodash";
import Operation from "antd/lib/transfer/operation";
import PaginationComponent from "../Common/PaginationComponent";

const RefillLogs = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });
  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Inputdata, setInputData] = useState({});
  const [componentList, setcomponentList] = useState([]);
  const [modelState, setmodelState] = useState(false);
  const [modelState1, setmodelState1] = useState(false);

  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [RMInventoryList, setRMInventoryList] = useState([]);
  const [ReservoirList, setReservoirList] = useState([]);
  const [ReservoirMasterList, setReservoirMasterList] = useState([]);
  const [ReservoirIdList, setReservoirIdList] = useState([]);
  const [UnitOfMeasurment, setUnitOfMeasurment] = useState('');
  const [RawMaterialInventory, setRawMaterialInventory] = useState([]);

  
  

  
  const [RMStorageList, setRMStorageList] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [Data, setData] = useState([]);
  const [PdfData, setPdfData] = useState([]);
  const [QRCodeArray, SetQRCodeArray] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [AdjustedQty, setAdjustedQty] = useState([]);
  const [MoldMaster, setMoldMaster] = useState([]);

  const [remarksInput, setRemarksInput] = useState({});

  const [Type, setType] = useState("");
  const [Quantity, setQuantity] = useState("");

  const [BatchCode, setBatchCode] = useState("");

  const [Remarks, setRemarks] = useState("");
  const [RawMaterialData, setRawMaterialData] = useState([]);

  const [ChekpointId, setChekpointId] = useState("");
  const [formData, setFormData] = useState({});
  const [Date, setDate] = useState([]);
  const [UIDList, setUIDList] = useState([]);
  const { Panel } = Collapse;
   const [CurrentPage, setCurrentPage] = useState(1);
        const [TotalPage, setTotalPage] = useState(0);
        const [PageSize, setPageSize] = useState(50);
    
  function callback(key) {
    console.log(key);
  }
  console.log(PdfData, "vhfvhdfvbhbvd");
  const handelOnPDfEnable = (e, input) => {
    let data = [...componentList];

    if (e.currentTarget.checked) {
      // Enable the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, Enable: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, Enable: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, Enable: false } : item;
      });
    }
    setcomponentList(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const handelSelectAll = (e) => {
    const isChecked = e.currentTarget.checked;

    // Update the componentList with updated 'Enable' values
    const updatedList = componentList.map((one) => ({
      ...one,
      Enable: isChecked,
    }));

    // Update state
    setcomponentList(updatedList);
    setPdfData(updatedList);
    SetEnableAllPdf(isChecked);
  };
   useEffect(() => {
      RawMatreialMaster()
    }, [CurrentPage, PageSize]);

  const columns = [
    // {
    //   key: "select",
    //   label: <input type="checkbox" onChange={handelSelectAll} />,
    //   content: (obj) => (
    //     <input type="checkbox" checked={obj['Enable']} onChange={(e) => handelOnPDfEnable(e, obj)} />
    //   ),
    // },
    { path: "DateTime", label: "Date",content: (obj) => (
      <label>{moment(obj.DateTime).format("DD-MM-YY")}</label>
    ) },
    { path: "DateTime", label: "Time",content: (obj) => (
      <label>{moment(obj.DateTime).format("hh:mm a")}</label>
    ) },
    { path: "Reservoir_Type", label: "Reservoir Type" },
    { path: "Reservoir_ID", label: "Reservoir ID" },

    
    { path: "RM_Type", label: "RM Type" },
    { path: "RM_ID", label: "RM ID" },
    { path: "Vendor", label: "Vendor" },
    {
      path: "InvoiceDate",
      label: "Invoice Date",
      content: (obj) => (
        <label>{moment(obj.InvoiceDate).format("DD-MM-YY")}</label>
      ),
    },
    { path: "InvoiceNo", label: "Invoice No" },

    
    { path: "Qty", label: "Quantity" },

    {
      path: "createdAt",
      label: "Created Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      path: "updatedAt",
      label: "Last Updated Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      key: "update",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("DynamicDataRights",RightName, "update")
          }
          onClick={() => {
            // setInputData(user)
            console.log(user, "dshvgvbskbvksjb");
            setUpdate(user);
            setopStatus("view");
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      ),
    },
    // { key: 'view', content: user => <button onClick={() => onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    // { key: 'delete', content: user => <button disabled={!getRightsForAccess('DynamicDataRights', RightName, "update")} onClick={() => onDelete(user)} className="btn btn-sm btn-danger"><FontAwesomeIcon icon={faTrash} /></button> }
  ];

  useEffect(() => {
    if (opStatus == "view") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setInputData(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  console.log(Update, "wkhfwehkf");
  useEffect(() => {

    Heading("Refill Reservoir");
    getRMTypeMaster();
    getRMInventoryList();
    getRMStorageMaster();
    getComponentCodeData();
    // RawMatreialMaster();
    reservoirMaster();
    RawMatreialInventory();
  }, []);
  const RawMatreialInventory = () => {
    axios
      .get(api.api + "RMDataEntry")
      .then((result) => {
        console.log(result.data,"Rm data entery data");
        setRawMaterialInventory(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const reservoirMaster = () => {
    axios
      .get(api.api + "reservoirMaster")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.Reservoir_Type,
          value: one.Reservoir_Type,
        }));
        setReservoirMasterList(result.data);
        const data = _.uniqBy(list, function (e) {
          return e.Name;
        });
        setReservoirList(data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRMInventoryList = () => {
    axios
      .get(api.api + "RMDataEntry")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.UniqueID,
          value: one.UniqueID,
          RM_ID: one.RM_ID,
          InvoiceDate: one.InvoiceDate,
          InvoiceNo: one.InvoiceNo,

        }));
        setRMInventoryList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRMStorageMaster = () => {
    axios
      .get(api.api + "rmStorageWater")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.StorageLocation,
          value: one.StorageLocation,
        }));
        setRMStorageList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRMTypeMaster = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
       
        setTemplateList(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getComponentCodeData = () => {
    // axios
    //   .get(api.api + "RM_Type")
    //   .then((result) => {
    //     setcomponentList(result.data);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };
  const RawMatreialMaster = () => {
    axios
      .put(api.api + "reservoirDataEntry",{ query: '', PageSize: PageSize, Page: CurrentPage })
      .then((result) => {
     if (result?.data?.data) {
          // Sort the data based on 'updatedAt'
          const sortedData = [...result.data.data].sort((a, b) =>
            b.updatedAt.localeCompare(a.updatedAt)
          );
  
          // Update the state with sorted data
          setRawMaterialData(sortedData);
          setTotalPage(result.data.totalDocuments);
        } else {
          console.error("Unexpected response structure:", result);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  
  const downloadPDF = async (qrCodeGroups, Inputdata) => {
    console.log(qrCodeGroups, Inputdata, "currect dowload function dta");
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(
      `Refill.pdf`
    );

    if (opStatus !== "view") {
      handleCloseModel();
    }
  };

  const A4Sheet = (QRCodeVisible, Inputdata) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    const stickersPerPage = 16; // 4x4 grid on each page
    if (QRCodeVisible) {
      const totalStickers = Number(Inputdata.NumOfStickers);
      // const stickersPerPage = 9; // 3x3 grid on each page
      for (let i = 0; i < totalStickers; i += stickersPerPage) {
        qrCodeGroups.push(
          [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
            (_, j) => i + j
          )
        );
      }
    }

    // Prepare the QR Code value to display in each QRCodeSVG
    const QrCode = `CC : ${Inputdata.RM_Type};BN : ${
      Inputdata.InvoiceNo
    };TC : ${Inputdata.TestReportNo};MD : ${moment(
      Inputdata.InvoiceDate
    ).format("DD-MM-YY")};ED : ${moment(Inputdata.ExpiryDate).format(
      "DD-MM-YY"
    )};QT : ${Inputdata.Qty}`;

    return (
      <div>
        {opStatus === "view" && (
          <Button
            type="primary"
            onClick={() => downloadPDF(qrCodeGroups, Inputdata)}
            style={{ marginBottom: "16px" }}
          >
            Download as PDF
          </Button>
        )}

        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter: "always" }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: `repeat(${Math.sqrt(
                    stickersPerPage
                  )}, 1fr)`, // 3 columns in each row
                  gridTemplateRows: `repeat(${Math.sqrt(
                    stickersPerPage
                  )}, auto)`, // 3 rows per page (auto height)
                  gap: "35px", // Optional: Adjust the gap between items as needed
                  justifyItems: "center",
                  alignItems: "center",
                }}
              >
                {group.map((index) => (
                  <div
                    className="d-flex flex-column justify-content-center align-items-center"
                    key={index}
                    style={{ textAlign: "center" }}
                  >
                    <QRCodeSVG level="M" value={QrCode} size={90} />{" "}
                    {/* Adjust the size of the QR code */}
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.RM_Type}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >
                      {Inputdata.InvoiceNo}
                    </p>
                    <p
                      style={{ fontSize: "10px", color: "black" }}
                      className="bolder"
                    >{`${index + 1} / ${Inputdata.NumOfStickers}`}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleSort = (sortColumn) => {
    if (RawMaterialData.length > 0) {
      const sorted = _.orderBy(
        RawMaterialData,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);

      setRawMaterialData(sorted);
    }
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleCloseModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const schema = {
    Reservoir_Type: joi.string().required(),
    Reservoir_ID: joi.string().required(),
    RM_Type: joi.string().required(),
    RM_ID: joi.string().required(),
    Vendor: joi.string().required(),
    InvoiceDate: joi.string().required(),
    InvoiceNo: joi.string().required(),
    DateTime: joi.string().required(),
    Qty: joi.number().required(),
    _id: joi.string(),
    UniqueID: joi.string(),

  };

  const handleOnChange = (e) => {
    try {
        const { name, value } = e.currentTarget;
        const Reservoirlist = [...ReservoirMasterList];
        const RMInventory = [...RMInventoryList];

        

        if (name === "Reservoir_Type") {
            const filteredArray = _.filter(Reservoirlist, { Reservoir_Type: value });
            setInputData((prev) => ({
              ...prev,
              [name]: value,
          }));
            if (filteredArray.length > 0) {
                const list = filteredArray.map((one) => ({
                    Name:one.Reservoir_ID,
                    value:one.UniqueID ,
                }));
             
                setReservoirIdList(list);
            } else {
                console.warn("No Reservoirs found for the selected Reservoir_Type.");
                setReservoirIdList([]);
            }
        } else if (name === "Reservoir_ID") {
               const json = JSON.parse(value);
            const filteredItem = _.find(Reservoirlist, { Reservoir_ID: json.Name });
            const filteredMeasurmentUnit= _.find(RawMaterialInventory, { RM_ID: filteredItem.RM_ID });
            if(filteredMeasurmentUnit){

           
            const UnitOfMeasurement= _.find(templateList, { RM_ID: filteredItem.RM_ID });
            const FilterUID= _.filter(RMInventory, { RM_ID: filteredItem.RM_ID });

            console.log("filteredItem",filteredMeasurmentUnit,RMInventory)
                  if(FilterUID.length > 0){
                    setUIDList(FilterUID)
                  }else {
                    setUIDList([])

                    console.warn("No Inventory found for the selected Reservoir ID.");
                }
            if (filteredItem) {
              // Update the input data with RM_Type and RM_ID
              setInputData((prev) => ({
                  ...prev,
                  Reservoir_ID:json.value || "",
                  Reservoir_Id:json.Name || "",                
                  RM_Type: filteredItem.RM_Type || "",
                  RM_Id: filteredMeasurmentUnit.RM_ID || "",
              }));
              // Log the current data for debugging
              console.log("Current data:", filteredMeasurmentUnit);
          
              // Check if UnitOfMeasurement exists in filteredMeasurmentUnit and update state
              if (UnitOfMeasurement?.UnitOfMeasurement) {
                  setUnitOfMeasurment(UnitOfMeasurement.UnitOfMeasurement);
              } else {
                  console.warn("UnitOfMeasurement is not available in filteredMeasurmentUnit.");
              }
          }
           else {
                console.warn("No Reservoir found for the selected Reservoir_ID.");
            }
          }else{
            swal(`No Inventory found for the selected Reservoir ID : ${JSON.parse(value).Name}`)
          }
        }else{
          setInputData((prev) => ({
            ...prev,
            [name]: value,
        }));
        }
        console.log(name,value,"fdshkbfsdfisd234")

        // Update the input data for the given field
       
    } catch (error) {
        console.error("Error in handleOnChange:", error.message);
    }
};

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };

  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    fileInputElement.accept = ".xlsx, .xls";
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener("change", (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });
        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "compoundCode/" + data._id, { data: data })
          .then((result) => {
            getComponentCodeData();
            toast.success(`Deleted  Successfully`, {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: "green", // Set your desired background color
                color: "white", // Set your desired text color
              },
            });
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };

  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${
              dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data) => {
    console.log(data, "cvosjnvjnv");
    const checksheet = { ...data };
    // delete checksheet.__v
    // delete checksheet.createdAt
    // delete checksheet.updatedAt
    // const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);
    //   return;
    // }
    setLoader(true);
    if (opStatus == "update") {
      axios
        .patch(api.api + "reservoirDataEntry/" + Update._id, checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          // getComponentCodeData();
          // setQRCodeVisible(true);
          RawMatreialMaster();

          handleCloseModel()
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "reservoirDataEntry", checksheet)
        .then((result) => {
          console.log(result, "cdisivbi");
          swal("Data Saved Successfully");
          // Split the QR codes into groups of 4
          setQRCodeVisible(true);
          const qrCodeGroups = [];
          const stickersPerPage = 16; // 4x4 grid on each page
          // if (QRCodeVisible) {
          const totalStickers = Number(Inputdata.NumOfStickers);
          // const stickersPerPage = 9; // 3x3 grid on each page
          for (let i = 0; i < totalStickers; i += stickersPerPage) {
            qrCodeGroups.push(
              [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
                (_, j) => i + j
              )
            );
          }
          // }
          // if (qrCodeGroups.length > 0) {
          //   downloadPDF(qrCodeGroups, Inputdata);
          // }
          // if(Result){
            handleCloseModel()
          // }
          RawMatreialMaster();

          // getComponentCodeData();

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  const downloadPDFforAll = (data) => {
    const pdf = [];

    data.map(
      (one) =>
        one.Enable &&
        [...Array(Math.min(one.NumOfStickers))].forEach((_, j) => {
          pdf.push({
            QrCode: `CC : ${one.CompoundCode};BN : ${one.InvoiceNo};TC : ${
              one.TestReportNo
            };MD : ${moment(one.InvoiceDate).format("DD-MM-YY")};ED : ${moment(
              one.ExpiryDate
            ).format("DD-MM-YY")};QT : ${one.Qty}`,
            index: j,
            InvoiceNo: one.InvoiceNo,
            CompoundCode: one.CompoundCode,
            TestReportNo: one.TestReportNo,

            NumOfStickers: one.NumOfStickers,
          });
        })
    );
    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };

  const handelONaddSpare = (Date, Type, Quantity, Remarks) => {
    if (Date && Type && Quantity) {
      setAdjustedQty((prev) => [
        ...prev,
        { Date: Date, Type: Type, Qty: Quantity, Remarks: Remarks },
      ]);
    } else {
      swal("Please Fill Required Fields");
    }
    setDate("");
    setQuantity("");

    setType("");
    setRemarks("");
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState}
        onHide={handleHideModel}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Refill Entry</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}
          <Row>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex ">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Reservoir Type
                </div>
                <div className="w-75">
                  {" "}
                  <AntdSelect
                    disabled={opStatus === "view" ? true:false}
                    placeholder="Select Reservoir Type."
                    onChange={(value) => {
                      handleOnChange({
                        currentTarget: { name: "Reservoir_Type", value: value },
                      });
                    }}
                    value={Inputdata.Reservoir_Type || []}
                    style={{ width: "100%" }}
                  >
                    {ReservoirList.map((one) => {
                      return (
                        <AntdSelect.Option value={one.Name}>
                          {one.Name}
                        </AntdSelect.Option>
                      );
                    })}
                  </AntdSelect>
                {errors.Reservoir_Type && (
                  <div className="alert small alert-danger">
                    {errors["Reservoir_Type"]}
                  </div>
                )}
                </div>

              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex ">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Reservoir ID
                </div>
                <div className="w-75">
                  {" "}
                  <AntdSelect
                    disabled={opStatus === "view" ? true:false}
                    onChange={(value) => {
                     
                      handleOnChange({
                        currentTarget: { name: "Reservoir_ID", value: value },
                      });
                    }}
                    placeholder="Select Reservoir ID."
                    value={Inputdata.Reservoir_Id || Inputdata.Reservoir_ID ||''}
                    style={{ width: "100%" }}
                  >
                    {ReservoirIdList.map((one) => {
                      return (
                        <AntdSelect.Option value={JSON.stringify({Name:one.Name,value:one.value})}>
                          {one.Name}
                        </AntdSelect.Option>
                      );
                    })}
                  </AntdSelect>
                {errors.Reservoir_Id && (
                  <div className="alert small alert-danger">
                    {errors["Reservoir_Id"]}
                  </div>

                )}
                </div>
              </div>
            </Col>
            
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex ">
                <div className="w-25" htmlFor="operationRejectionCost">
                  RM Type
                </div>
                <div className="w-75">
                <input
                    required
                    onChange={handleOnChange}
                     disabled={true}
                     style={{width: '100%'}}
                    placeholder="RM Type"
                    className="form-control form-control-sm"
                    type="text"
                    name="RM_Type"
                    value={
                      (Inputdata.RM_Type &&
                        Inputdata.RM_Type) ||
                      ""
                    }
                  />
                
                {errors.RM_Type && (
                  <div className="alert small alert-danger">
                    {errors["RM_Type"]}
                  </div>
                )}
                </div>

              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  RM ID
                </div>
                <div className="w-75">
                <input
                    required
                    onChange={handleOnChange}
                     disabled={true}
                     style={{width: '100%'}}

                    placeholder="RM ID"
                    className="form-control form-control-sm"
                    type="text"
                    name="RM_ID"
                    value={
                      (Inputdata.RM_Id &&
                        Inputdata.RM_Id) ||  (Inputdata.RM_ID &&
                          Inputdata.RM_ID) ||
                      ""
                    }
                  />
                {errors.RM_Id && (
                  <div className="alert small alert-danger">
                    {errors["RM_Id"]}
                  </div>
                )}
                </div>

              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Unique ID 
                </div>
                <div className="w-75">
                  <AntdSelect
                    disabled={opStatus === "view" ? true:false}
                    placeholder="Select  Unique ID / Invoice Date / Invoice Number / RM ID."
                    onChange={(value) => {
                     
                      
                      handleOnChange({
                        currentTarget: { name: "RM_ID", value: value },
                      });
                    }}
                    value={Inputdata.RM_ID || []}
                    style={{ width: "100%" }}
                  >
                    {UIDList.map((one) => {
                      return (
                        <AntdSelect.Option value={one.Name}>
                          {one.Name +' / '+ moment(one.InvoiceDate).format('DD-MM-YYYY') +' / '+ one.InvoiceNo +' / '+ one.RM_ID}
                        </AntdSelect.Option>
                      );
                    })}
                  </AntdSelect>
                {errors.RM_ID && (
                  <div className="alert small alert-danger">
                    {errors["RM_ID"]}
                  </div>
                )}
                </div>

              </div>
            </Col>
            {/* <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Invoice Date
                </div>
                <div className="w-75">
                  <input
                    required
                    onChange={handleOnChange}
                    disabled={opStatus === "view" ? true:false}
                    placeholder="Invoice Date"
                    className="form-control form-control-sm"
                    type="date"
                    name="InvoiceDate"
                    value={
                      (Inputdata.InvoiceDate &&
                        Inputdata.InvoiceDate.split("T")[0]) ||
                      ""
                    }
                  />
                {errors.InvoiceDate && (
                  <div className="alert small alert-danger">
                    {errors["InvoiceDate"]}
                  </div>
                )}
                </div>

              </div>
            </Col>{" "}
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Invoice No
                </div>
                <div className="w-75">
                  <input
                    required
                    disabled={opStatus === "view" ? true:false}
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control form-control-sm"
                    type="text"
                    // min="0"
                    placeholder="Invoice No"
                    name="InvoiceNo"
                    value={Inputdata.InvoiceNo}
                  />
                {errors.InvoiceNo && (
                  <div className="alert small alert-danger">
                    {errors["InvoiceNo"]}
                  </div>
                )}
                </div>

              </div>
            </Col>
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  Date Time
                </div>
                <div className="w-75">
                  <input
                    required
                    onChange={handleOnChange}
                    disabled={opStatus === "view" ? true:false}
                    placeholder="DD-MM-YYYY"
                    className="form-control form-control-sm"
                    type="date"
                    name="DateTime"
                    value={
                      (Inputdata.DateTime &&
                        Inputdata.DateTime.split("T")[0]) ||
                      ""
                    }
                    />
                    {errors.DateTime && (
                      <div className="alert small alert-danger">
                        {errors["DateTime"]}
                      </div>
                    )}
                </div>

              </div>
            </Col>{" "} */}
            <Col sm={12}>
              <div className="form-group mt-2 w-100 d-flex">
                <div className="w-25" htmlFor="operationRejectionCost">
                  {console.log(UnitOfMeasurment,"fwkjfweiyfgi")}
                  {" "}
                  Quantity {UnitOfMeasurment.length > 0 && '('+UnitOfMeasurment+')'}
                </div>
                <div className="w-75">
                  <input
                    required
                    disabled={opStatus === "view" ? true:false}
                    onChange={handleOnChange}
                    style={{ width: "100%" }}
                    placeholder="Qty"
                    className="form-control form-control-sm"
                    type="number"
                    // min="0"
                    name="Qty"
                    value={Inputdata.Qty}
                  />
                {errors.Qty && (
                  <div className="alert small alert-danger">
                    {errors["Qty"]}
                  </div>
                )}
              </div>
                </div>

            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          {opStatus === "view" ? (
            ""
          ) : (
            <Button
              variant="primary"
              onClick={() => {
                const error = validateCheckCheckPoints(rows);
                if (error.IsError) {
                  swal("ERROR", error.message.join(", "), { dangerMode: true });
                } else {
                  handelSaveData(Inputdata);
                }
              }}
            >
              Submit
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState1}
        onHide={handleHideModel1}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Inventory Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

          {console.log(Inputdata.NumOfStickers, "snsdonsdn")}
          <div className="a4-sheet">
            {
              QRCodeArray && QRCodeArray.length > 0 && (
                <div>
                  <Button
                    type="primary"
                    onClick={() => downloadPDF(QRCodeArray, Inputdata)}
                    style={{ marginBottom: "16px" }}
                  >
                    Download as PDF
                  </Button>

                  {QRCodeArray.map((group, index) => (
                    <div className="a4-sheet-scrollable">
                      <div
                        className="a4-page"
                        // key={pageIndex}
                        style={{ pageBreakAfter: "always" }}
                      >
                        <div
                                                   style={{
                                                     display: "grid",
                                                     gridTemplateColumns: `repeat(${Math.sqrt(
                                                       16
                                                     )}, 1fr)`, // 3 columns in each row
                                                     gridTemplateRows: `repeat(${Math.sqrt(
                                                       16
                                                     )}, auto)`, // 3 rows per page (auto height)
                                                     gap: "57px", // Optional: Adjust the gap between items as needed
                                                     justifyItems: "center",
                                                     alignItems: "center",
                                                   }}
                                                 >
                                                   {group.map((one, index) => (
                                                     <div
                                                       className="d-flex flex-column justify-content-center align-items-center "
                                                       key={index}
                                                       style={{ textAlign: "center",marginBottom:'10px'}}
                                                     >
                                                       <QRCodeSVG
                                                         value={one.QrCode}
                                                         level={'M'}
                                                         size={80}
                                                         style={{marginBottom:'3px'}}
                                                       />{" "}
                              {/* Adjust the size of the QR code */}
                              <p
                                 style={{
                                  fontSize: "9px",
                                  color: "black",
                                  letterSpacing: "0.5px",
                                  lineHeight: "1.2",
                                }}
                                className="bolder p-0 m-0"
                              >
                                {one.RM_Type}
                                {one.InvoiceNo}
                                {`${1 + one.index} / ${one.NumOfStickers}`}
                              </p>
                             
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )
              // [...Array(Number(Inputdata.NumOfStickers))].map((_, index) => (
              //   <Space className="qr-space" key={index} direction="vertical" align="center">
              //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
              //     <p>{index + 1 + ' / ' + Inputdata.NumOfStickers}</p>
              //   </Space>
              // ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel1()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {
        <button
          disabled={!getRightsForAccess("DynamicDataRights", RightName, "write")}
          className="btn-sm btn-success mx-2 "
          onClick={() => {
            setQRCodeVisible(false);
            setmodelState(true);
            setInputData({});
            setUpdate({});
            setSelectedTemplate({});
          }}
        >
          Add Refill
        </button>
      }
      {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    // onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button> */}
      {/* {getRightsForAccess('DynamicDataRights', RightName, "write") && <Excelimport />} */}
      {/* {PdfData && PdfData.length > 0 && EnableAllPdf && (
        <button
          type="button"
          className="btn-sm btn-primary"
          onClick={() => downloadPDFforAll(PdfData)}
        >
          Download PDFs
        </button>
      )} */}
      {RawMaterialData.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={RawMaterialData}

        />
      )}
      {RawMaterialData.length > 0 && <div className="float-end m-3">
                <PaginationComponent  defaultCurrent={CurrentPage} total={TotalPage} CurrentPageNumber={(currentpage, pagesize) => { setCurrentPage(currentpage); setPageSize(pagesize) }} />
            </div>}
    </>
  );
};

export default RefillLogs;
